import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/finance7.png";  // Adjust the path as needed

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="bg-[#000300] text-[#fff] shadow-[0px_-5px_10px_rgba(0,0,0,0.1)] pt-5 pb-0.5 md:pl-10">
        <div className="container mx-auto px-4 md:px-0 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-8 lg:gap-8 xl:gap-15 md:gap-4">
          {/* Column 1: Company Information */}
          <div className="text-center md:text-left lg:pl-[2rem] xl:pl-[2rem]">
            <img 
              src={logo} 
              alt="Senior Vault Capital Logo" 
              className="w-auto h-7 sm:h-8 md:h-9 mx-auto md:mx-0 mb-3 object-contain"
              style={{
                imageRendering: '-webkit-optimize-contrast',
                imageRendering: 'crisp-edges'
              }}
            />
            <p className="text-xs md:text-sm leading-relaxed">
              Senior Vault Capital empower individuals and businesses to achieve their financial aspirations through expert capital growth solutions. 
              From securing your dream home to expanding your business or building long-term wealth, we're dedicated to helping you reach your goal.
            </p>
          </div>

          {/* Column 2: Contact Information */}
          <div className="text-center md:text-left lg:pl-[8rem] xl:pl-[9rem] md:pl-[3.5rem]">
            <h2 className="text-sm md:text-base font-bold pb-[1.2rem]">Contact Information</h2>
            <p className="text-xs md:text-sm pb-2 lg:pb-0.5">
              <strong>Email:</strong> support@seniorvaultcapital.com
            </p>
            <p className="text-xs md:text-sm pb-2">
              <strong>Address:</strong> 1101 Lake Washington Blvd North
            </p>
            
          </div>

          {/* Column 3: Quick Links */}
          <div className="text-center md:text-left lg:pl-[8.7rem] lg:pl-[10.7rem] md:pl-[4.5rem]">
            <h3 className="text-sm md:text-base font-semibold pb-[0.8rem]">Quick Links</h3>
            <ul className="space-y-1">
               <li>
                <Link to="/about"  onClick={() => window.scrollTo(0, 0)} className="text-xs md:text-sm hover:text-gray-300 transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/privacypolicy"  onClick={() => window.scrollTo(0, 0)} className="text-xs md:text-sm hover:text-gray-300 transition">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/termsofservice"  onClick={() => window.scrollTo(0, 0)} className="text-xs md:text-sm hover:text-gray-300 transition">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cert"  onClick={() => window.scrollTo(0, 0)} className="text-xs md:text-sm hover:text-gray-300 transition">
                  Cert of Authorization
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider and Copyright */}
        <div className="border-t border-gray-700 mt-1 py-4 text-center">
          <p className="text-xs md:text-sm">&copy; {currentYear} Senior Vault Capital. All Rights Reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;